export enum AchievementType {
  Proactivity = "Proactivity",
  Openness = "Openness",
  Responsibility = "Responsibility",
  Participation = "Participation",
}

export class AchievementModel {
  public done: boolean = false;
  constructor(public index: number, public type: AchievementType) {
  }
}
